export const FileBrowserTestIdFactory = {
    getBrowserTestId: (testId) => `${testId}-browser`,
    getDownloadDesktopAppTestId: (testId) => `${testId}-download-desktop-app`,
    getDownloadDirTestId: (testId) => `${testId}-download-dir`,
    getEntryDownloadTestId: (testId, entryId) => `${testId}-download-${entryId}`,
    getEmptyStateTestId: (testId) => `${testId}-empty`,
    getEntryExtensionTestId: (entryId) => `${entryId}-extension`,
    getEntryIncompleteTestId: (entryId) => `${entryId}-stuck`,
    getEntryInProgressTestId: (entryId) => `${entryId}-updating`,
    getEntryMenuTriggerTestId: (entryId) => `browser-menu-trigger-${entryId}`,
    getEntryNameTestId: (testId, entryId) => `${testId}-entry-${entryId}`,
    getEntryPreviewableTestId: (entryId) => `file-${entryId}-previewable`,
    getExtensionFilterTestId: (testId) => `${testId}-extension-filter`,
    getLoadingTestId: (testId) => `${testId}-loading`,
    getNoMatchTestId: (testId) => `${testId}-no-match`,
    getOpenDesktopAppTestId: (testId) => `${testId}-open-desktop-app`,
    getRetryTestId: (testId) => `${testId}-retry`,
};
